import { supportsPassiveOption } from '@Utils/supports-passive-option';
import { underscore_debounce } from '@Utils/underscore-debounce';
import { underscore_throttle } from '@Utils/underscore-throttle';

window.ci_Utils = {
    supportsPassiveOption,
    underscore_debounce,
    underscore_throttle
};